import { memo } from 'react'

import { CardLazyWrapper } from '@components/cards/RaCardLazyWrapper/RaCardLazyWrapper'
import {
  RaContainer,
  RaGrid,
  RaGridItem,
  RaHeading,
  RaIllustration,
} from '@components/core/index.core'
import { AcfGenericCardGridProps } from '@typings'
import { Loop } from '@utilities/helpers/core.helpers'

import styles from './acf-generic-card-grid.module.scss'

// Column spans (out of RaGrid's default 12) per editor-selected `columns` (1-4).
const COLUMN_SPANS: Record<number, { lg: number; md: number; sm: number }> = {
  1: { lg: 12, md: 12, sm: 12 },
  2: { lg: 6, md: 6, sm: 12 },
  3: { lg: 4, md: 6, sm: 12 },
  4: { lg: 3, md: 6, sm: 12 },
}

export const AcfGenericCardGrid = memo((props: AcfGenericCardGridProps) => {
  if (!props?.items?.length) return null
  const span = COLUMN_SPANS[props.columns] ?? COLUMN_SPANS[3]

  return (
    <RaContainer>
      <RaIllustration index={0} />
      {props.heading && <RaHeading component="h2">{props.heading}</RaHeading>}
      <RaGrid>
        {Loop(props.items, (item, i) => (
          <RaGridItem
            key={i}
            xs={12}
            sm={span.sm}
            md={span.md}
            lg={span.lg}
            customClassNames={styles['grid-item']}>
            <CardLazyWrapper
              renderCard="generic"
              props={{ ...item, uniformImage: props.uniformImages }}
            />
          </RaGridItem>
        ))}
      </RaGrid>
    </RaContainer>
  )
})

AcfGenericCardGrid.displayName = 'AcfGenericCardGrid'
